var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1479_21481)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.557 0.520996C11.7523 0.520996 0.558594 11.7575 0.558594 25.6216C0.558594 36.7092 7.72108 46.1167 17.657 49.436C18.907 49.6666 19.3633 48.8916 19.3633 48.2265C19.3633 47.6304 19.3414 46.0523 19.3289 43.9581C12.3742 45.4751 10.907 40.5933 10.907 40.5933C9.7711 37.6944 8.13204 36.9226 8.13204 36.9226C5.86173 35.3648 8.30389 35.3962 8.30389 35.3962C10.8117 35.5734 12.132 37.983 12.132 37.983C14.3633 41.8184 17.9836 40.7109 19.4086 40.0678C19.6352 38.4457 20.282 37.3398 20.9961 36.7124C15.4445 36.0786 9.60858 33.9263 9.60858 24.3087C9.60858 21.5682 10.582 19.3281 12.182 17.5727C11.9242 16.9374 11.0664 14.3867 12.4258 10.9309C12.4258 10.9309 14.5258 10.2563 19.3008 13.5035C21.2961 12.9466 23.4336 12.6689 25.5602 12.658C27.6836 12.6689 29.8227 12.9466 31.8195 13.5035C36.5914 10.2563 38.6867 10.9309 38.6867 10.9309C40.0508 14.3867 39.193 16.9374 38.9351 17.5727C40.5383 19.3281 41.5055 21.5682 41.5055 24.3087C41.5055 33.9499 35.6602 36.0723 30.0914 36.6935C30.9883 37.4684 31.7883 38.9995 31.7883 41.3416C31.7883 44.697 31.757 47.403 31.757 48.2265C31.757 48.8979 32.2071 49.6791 33.4758 49.4329C43.4024 46.1072 50.5586 36.706 50.5586 25.6216C50.5586 11.7575 39.3648 0.520996 25.557 0.520996Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1479_21481"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(0.558594)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.901a4ad7bf47a7b52626960e9351381a.svg";
export { ForwardRef as ReactComponent };